import { loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm, monitoringOff, monitoringOn } from '@assets/images/main/index';
import {
  Icon3d3d,
  Icon3dAlert,
  Icon3dCheck,
  Icon3dCycle,
  Icon3dDetect,
  Icon3dLocation,
  Icon3dMap2,
  Icon3dMeter,
  Icon3dSchedule,
  Icon3dServer,
  IconDownload,
} from '@assets/images/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  iotBannerBg,
  iotBannerProduct,
  iotScreenshot1D,
  iotScreenshot1M,
  iotScreenshot1T,
  iotScreenshot2D,
  iotScreenshot2M,
  iotScreenshot2T,
  iotScreenshot3D,
  iotScreenshot3M,
  iotScreenshot3T,
} from '@assets/images/main/sensor';
import { IconAirQualityInv, IconBellInv, IconCo2Inv, IconLoraSensorInv } from '@assets/images/main/icon';

export default {
  banner: {
    title: 'Even complex devices and diverse data<br/>work as one with ORBRO.',
    desc: 'IoT data from the field — including temperature, humidity, air quality, pressure, CO₂, intrusion detection, power control, and emergency bells<br/>— is collected and visualized in real time on ORBRO OS.',

    schemeTitle: 'ORBRO provides sensors tailored to your industrial environment.',
    bgImg: iotBannerBg,
    productImg: iotBannerProduct,
  },

  func: {
    title: 'Explore Features',
    desc: 'Discover the various capabilities of our sensors.',

    data: [
      {
        img: Icon3dMap2,
        title: 'Real-Time Sensor Monitoring',
        desc: 'Monitor sensor status, battery levels, and signal strength in real time through ORBRO OS.',
      },
      {
        img: Icon3dCheck,
        title: 'Map-Based Sensor Placement',
        desc: 'Visualize installed sensor locations on a map or floor plan to easily monitor area-specific status.',
      },
      {
        img: Icon3dSchedule,
        title: 'Event History & Alert Logs',
        desc: 'Review abnormal events and sent alerts in a timeline, and utilize the logs for root cause analysis.',
      },
      {
        img: Icon3dLocation,
        title: 'Sensor Group Management by Zone',
        desc: 'Group sensors by installation zone or use case for intuitive dashboard management.',
      },
      {
        img: Icon3dAlert,
        title: 'Outlier Detection & Threshold Setting',
        desc: 'Set thresholds per sensor; the system sends alerts automatically when exceeded.',
      },
      {
        img: Icon3dAlert,
        title: 'Custom Alert Rules by Zone',
        desc: 'Configure more sensitive alert rules for high-risk zones and adjust sensitivity accordingly.',
      },
      {
        img: IconDownload,
        title: 'Data History & Export',
        desc: 'Measurement values and event logs are saved automatically and can be exported as CSV or Excel files.',
      },
      {
        img: Icon3dServer,
        title: 'External System Integration (API)',
        desc: 'APIs are available for access control, equipment management, and event-triggered automation.',
      },
    ],
  },

  bannerData: [
    {
      icon: loraSensorOn,
      iconInv: IconLoraSensorInv,
      iconOff: loraSensorOff,
      image: '',
      iconText: 'LoRA Sensor',
      sub: 'New',
      link: '/en/iot/LoRASensor',
    },
    {
      icon: coOn,
      iconInv: IconCo2Inv,
      iconOff: coOff,
      image: '',
      iconText: 'CO₂ Detector',
      sub: 'New',
      link: '/en/iot/co2',
    },
    {
      icon: airOn,
      iconInv: IconAirQualityInv,
      iconOff: airOff,
      image: '',
      iconText: 'Air Quality Monitor',
      sub: 'New',
      link: '/en/iot/air',
    },
    {
      icon: monitoringOn,
      iconInv: IconBellInv,
      iconOff: monitoringOff,
      image: '',
      iconText: 'Emergency Bell',
      sub: '',
      link: '/en/iot/bell',
    },
  ],

  screenShot: [
    {
      title: 'Real-Time Unified Dashboard for All Sensors',
      desc: 'Visualize data from various IoT sensors in real time on ORBRO OS<br/>and intuitively manage sensor data and locations on a single screen.',
      img: {
        desktop: iotScreenshot1D,
        tablet: iotScreenshot1T,
        mobile: iotScreenshot1M,
      },
    },
    {
      title: 'Time-Series Graphs of Sensor Data',
      desc: 'Check measurements by time intervals to detect environmental changes and anomalies early.',
      img: {
        desktop: iotScreenshot2D,
        tablet: iotScreenshot2T,
        mobile: iotScreenshot2M,
      },
    },
    {
      title: 'Instant Alerts for Anomaly Detection',
      desc: 'When a sensor detects values beyond its set range or unusual behavior, ORBRO OS immediately alerts administrators for quick response.',
      img: {
        desktop: iotScreenshot3D,
        tablet: iotScreenshot3T,
        mobile: iotScreenshot3M,
      },
    },
  ],

  FAQ: [
    {
      title: 'How frequently is sensor data updated?',
      description: 'The default update interval is 1–5 minutes, with real-time transmission supported for some sensors.',
    },
    {
      title: 'Can it operate offline?',
      description: 'Some sensors store data locally and transmit it once the network is restored.',
    },
    {
      title: 'Can multiple sensors be installed simultaneously?',
      description: 'ORBRO OS is designed to connect and manage multiple sensors at once.',
    },
    {
      title: 'Is integration with external devices possible?',
      description: 'Yes, via API, integration with systems like access control and automation equipment is supported.',
    },
    {
      title: 'How long does the sensor battery last?',
      description: 'Varies by product, but LoRa sensors typically last 6 months to over a year with real-time battery monitoring.',
    },
    {
      title: 'Are all sensors compatible with ORBRO OS?',
      description: 'All ORBRO-certified sensors integrate automatically, and third-party sensors using Modbus or RS-485 may also be supported.',
    },
    {
      title: 'Will I be notified of sensor malfunctions?',
      description: 'Yes. ORBRO OS detects issues like disconnection or low battery and sends notifications accordingly.',
    },
    {
      title: 'Can alerts be sent to multiple users?',
      description: 'Yes. Alerts can be sent to groups by department or role.',
    },
  ],
};
